import React, { useEffect } from 'react';
import * as FiIcons from 'react-icons/fi';
import StatusDot from '../status/StatusDot';

/**
 * T13.4 — click a node → stats sidebar. Esc closes; focus moves to panel.
 */
function NodeDetailSidebar({ node, agents, onClose, onOpenAgent }) {
  useEffect(() => {
    const handleKeyDown = (domEvent) => {
      if (domEvent.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  if (!node) {
    return (
      <aside className="brain-sidebar brain-sidebar--empty">
        <FiIcons.FiMousePointer />
        <p>Select a node</p>
        <span>Click any agent or tool in the graph to inspect live stats.</span>
      </aside>
    );
  }

  const agent = agents.find((candidate) => candidate.id === node.data.agentId);

  return (
    <aside className="brain-sidebar">
      <header className="brain-sidebar__head">
        <div>
          <strong>{node.data.name}</strong>
          <span>{node.data.role}</span>
        </div>
        <button aria-label="Close details" className="modal__close" onClick={onClose} type="button">
          <FiIcons.FiX />
        </button>
      </header>

      {agent ? (
        <dl className="brain-sidebar__stats">
          <div>
            <dt>Status</dt>
            <dd><span className="brain-sidebar__status"><StatusDot status={agent.status} pulse={agent.status === 'running'} /> {agent.status}</span></dd>
          </div>
          <div>
            <dt>Tasks completed</dt>
            <dd>{agent.tasks}</dd>
          </div>
          <div>
            <dt>Progress</dt>
            <dd>{agent.progress}%</dd>
          </div>
        </dl>
      ) : (
        <dl className="brain-sidebar__stats">
          <div>
            <dt>Kind</dt>
            <dd>{node.type}</dd>
          </div>
          <div>
            <dt>Identifier</dt>
            <dd><code>{node.id}</code></dd>
          </div>
        </dl>
      )}

      {agent && (
        <button className="primary-button" onClick={() => onOpenAgent(agent.id)} type="button">
          <FiIcons.FiExternalLink /> Open agent detail
        </button>
      )}
    </aside>
  );
}

export default NodeDetailSidebar;
